import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { WideColorButton } from '../ColorButtons/ColorButtons';

const styles = {
  centered: {
    textAlign: "center"
  },
  display: {
    display: "flex",
    justifyContent: "center",
    alignItems:"center",
  }
};

const ModalMessage = props => {

  const { classes, catersName, submit } = props;
  const [open, setOpen] = useState(false)

  const close = () => {
    props.closeModal();
    if(submit)
      sessionStorage.removeItem("showWarning");

    setOpen(false);
  };

  useEffect(()=>{
    setOpen(props.event);
  },[props])

  return (
    <Dialog
        open={open}
        className={classes.centered}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Your Event Portal"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {submit ? (
              <span>
              Thank you for submitting your comments. { catersName } has been notified your comments have been submitted.
            </span>
            ) : (
              <span>
                To send all comments to your caterer, make sure to use the Submit All Comments button at the bottom.
              </span>
            )}
              
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.display}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12}>
              <WideColorButton onClick={close} variant="outlined" >
                Ok
              </WideColorButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
  );
};

ModalMessage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ModalMessage);
